<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>ສິນຄ້າຮັບເຂົ້າ</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="ຊອກຫາ" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-btn slot="activator" color="primary" dark class="mb-2">ເພີ່ມ</v-btn>
          <v-card>
            <v-card-title>
            <span class="headline fontLao">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap class="fontLao">
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.order" type="text" label="Order#"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.orderdate" type="date" label="Order Date"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.invoiceno" type="text" label="Invoice No"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.invoicedate" type="date" label="Invoice Date"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.importdate" type="date" label="Import Date"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12> 
                    <v-select v-model="editedItem.sid" :items="suppliers" item-value="id" item-text="name" label="ຜູ້ສະໜອງ" ></v-select> 
                  </v-flex>
                  <!-- <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.taxid" type="number" label="Tax Identification"></v-text-field>
                  </v-flex> -->
                  <!-- <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.total" type="number" label="Total"></v-text-field>
                  </v-flex> -->
                  <!-- <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.vat" type="number" label="VAT"></v-text-field>
                  </v-flex> -->
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.grandtotal" type="number" label="Grand Total"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer >
              <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table  
      :pagination.sync="pagination"
      :headers="headers" :items="mydata" :search="search" :rows-per-page-items=[10,20,50,100,500] class="elevation-1 fixtable">
        <template slot="items" slot-scope="props">
          <td class="fix">{{ props.item.order }}</td>
          <td class="fix">{{ props.item.orderdate }}</td>
          <td class="fix">{{ props.item.invoiceno }}</td>
          <td class="fix">{{ props.item.invoicedate }}</td>
          <td class="fix">{{ props.item.importdate }}</td>
          <td class="fix">{{ props.item.sname }}</td>
          <!-- <td class="fix">{{ props.item.taxid }}</td> -->
          <!-- <td class="fix">{{ _P(props.item.total) }}</td> -->
          <!-- <td class="fix">{{ props.item.vat }}</td> -->
          <td class="fix">{{ _P(props.item.grandtotal)  }}</td>
          <td class="fix">{{ props.item.items }}</td>
          <!-- <td class="fix">
            <span v-if="props.item.back > 0" class="red--text">{{ props.item.back }}</span>
            <span v-if="props.item.back == 0">{{ props.item.back }}</span>
          </td> -->
          <td class="fix">
            <span v-if="_F(props.item.balance) != _F(props.item.grandtotal)" class="red--text">
              {{ _P(props.item.balance) }}
            </span>
            <span v-if="props.item.balance == props.item.grandtotal">{{ _P(props.item.balance) }}</span>
          </td>
          <td class="text-xs-center px-0 fix">
            <v-icon small @click="gotopageStockIn(props.item)" >arrow_upward</v-icon>
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> 
            <v-icon small @click="deleteItem(props.item)" > delete </v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import db from '@/firebase/init'
import moment from 'moment'
// moment(new Date()).format('YYYY-MM-DD')
  export default {
    name:'import',
    data: () => ({
      dialog: false,
      search: '',
      pagination : {'sortBy': 'importdate', 'descending': true, 'rowsPerPage': -1},
      suppliers: [],
      headers: [
        {text: 'Order#', value: 'order' ,align: 'left'},
        {text: 'Order Date', value: 'orderdate' ,align: 'left'},
        {text: 'Invoice No', value: 'invoiceno' ,align: 'left'},
        {text: 'Invoice Date', value: 'invoicedate' ,align: 'left'},
        {text: 'Import Date',sortable: true, value: 'importdate' ,align: 'left'},
        {text: 'ຜູ້ສະໜອງ', value: 'sname'  ,align: 'left'},
        // {text: 'Tax ID', value: 'taxid' ,align: 'left'},
        // {text: 'Total', value: 'total' ,align: 'left'},
        // {text: 'VAT', value: 'vat' ,align: 'left'},
        {text: 'Grand Total', value: 'grandtotal' ,align: 'left'},
        {text: 'ຈ/ນ ລາຍການ', value: 'items' ,align: 'left'},
        // {text: 'ຄົງເຫຼືອ', value: 'back' ,align: 'left'},
        {text: 'ລວມເປັນ', value: 'balance' ,align: 'left'},
        {text: 'ການເຄື່ອນໄຫວ', value: 'action', sortable: false,align: 'center'}
      ],
      mydata: [],
      editedIndex: -1,
      editedItem: {
        order: null,
        orderdate: null,
        invoiceno: null,
        invoicedate: null,
        importdate: null,
        sid: null,
        // taxid: null,
        // total: null,
        // vat: null,
        grandtotal: null,
        stt:1
      },
      defaultItem: {
        order: null,
        orderdate: null,
        invoiceno: null,
        invoicedate: null,
        importdate: null,
        sid: null,
        // taxid: null,
        // total: null,
        // vat: null,
        grandtotal: null,
        stt:1
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'ເພີ່ມ' : 'ແກ້ໄຂ'
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {
      this.initialize()
      this.initsuppliers()
    },
    methods: {
    _P (value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    _D(value) {
      let val = (value / 1).toFixed(0).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    _F (value) {
   // return(value)
    //var val =parseFloat(value).toFixed(2)
    //console.log(value,val)
    return value
    },
    initialize () {
      let tdata = []
                var tsup =[];
             db.collection('suppliers').where("stt","==",1).get().then(snapshotc => {
                var c =[] 
             snapshotc.forEach(d=>{
               c[d.id]=d.data()
             })
             tsup = c
            }).catch(function(error) {
              console.log("Error getting document:", error);
            })
      let ref = db.collection('import').where("stt","==",1).get()
      .then(snapshot => {
  
        snapshot.forEach( doc => {
          let tmpdata =doc.data()
          tmpdata.id =doc.id
          const tmporderdate = doc.get('orderdate')
          const orderdate = moment(tmporderdate.toDate()).format('YYYY-MM-DD')
          const tmpinvoicedate = doc.get('invoicedate')
          const invoicedate = moment(tmpinvoicedate.toDate()).format('YYYY-MM-DD')
          const tmpimportdate = doc.get('importdate')
          const importdate = moment(tmpimportdate.toDate()).format('YYYY-MM-DD')
          tmpdata.orderdate = orderdate
          tmpdata.invoicedate = invoicedate
          tmpdata.importdate = importdate
          if(doc.data().sid){
           tmpdata.sname = tsup[doc.data().sid].name;
          }
          if(doc.data().balance!=doc.data().grandtotal)
          {
            this.findImport(doc.id)
            console.log(doc.id,doc.data().invoiceno,'Total !=',doc.data().grandtotal,doc.data().balance)
          }
          tdata.push(tmpdata)
        })
        this.mydata=tdata
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
      // db.collection('import').where("stt","==",1).get()
      // .then(snapshot => {
      //   snapshot.forEach(async doc => {
      //     const date = doc.data().importdate
      //     const ref = await db.collection('import').doc(doc.id)
      //     await db.collection('stock').where("stt","==",1).where('importref','==',ref).get().then(snapshots => {
      //       for (let index = 0; index < snapshots.docs.length; index++) {
      //         const ref = snapshots.docs[index].ref;
      //         ref.set({ stockdate: date }, { merge: true })
      //       }
      //     })
      //   })
      // })
      // db.collection('import').where("stt","==",0).get()
      // .then(snapshot => {
      //   snapshot.forEach(async doc => {
      //     const ref = await db.collection('import').doc(doc.id)
      //     await db.collection('stock').where("stt","==",1).where('importref','==',ref).get().then(snapshots => {
      //       for (let index = 0; index < snapshots.docs.length; index++) {
      //         const ref = snapshots.docs[index].ref;
      //         ref.update({stt:0})
      //       }
      //     })
      //   })
      // })
    },
    
     findImport (importid) {
    //  let tdata = []
      var importref =  db.collection('import').doc(importid)
   
      let ref = db.collection('stock').where('importref','==',importref).where('stock','==','in').where("stt","==",1).get()
      .then( async snapshot => {
        var balance = 0
      //    console.log(balance)

        snapshot.forEach( doc => {
          if (doc.exists){
            let tmpdata =doc.data()
            tmpdata.id =doc.id
      //    console.log(balance,doc.data().amount)

          balance = this.financial(Number(doc.data().amount) + Number(balance))
          console.log(doc.data().amount,doc.data().qty,balance)
         

           // tdata.push(tmpdata)
          }
        })
         console.log('Total',balance)
         importref.update({balance:balance})

       // this.mydata=tdata
       // return balance
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    },
    initsuppliers () {
      let sdata = []
      db.collection('suppliers').where("stt","==",1).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let tmpdata = doc.data()
          tmpdata.id = doc.id
          sdata.push(tmpdata)
        })
        this.suppliers = sdata
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    },
    editItem (item) {
      this.editedIndex = this.mydata.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      console.log(item)
    },
    deleteItem (item) {
      const index = this.mydata.indexOf(item)
      if ( confirm('Are you sure you want to delete this item ('+item.order+' )?')) {
        db.collection('import').doc(item.id).update({stt:0})
        const ref = db.collection('import').doc(item.id)
          db.collection('stock').where("stt","==",1).where('importref','==',ref).get().then(snapshots => {
            for (let index = 0; index < snapshots.docs.length; index++) {
              const ref = snapshots.docs[index].ref;
              ref.update({stt:0})
            }
          })
        this.mydata.splice(index, 1)
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        delete this.editedItem.sname;
        // this.editedItem.taxid =parseInt(this.editedItem.taxid)
        // this.editedItem.total =parseInt(this.editedItem.total)
        // this.editedItem.vat =parseInt(this.editedItem.vat)
        this.editedItem.grandtotal =parseFloat(this.editedItem.grandtotal)
        this.editedItem.orderdate = new Date(this.editedItem.orderdate)
        this.editedItem.invoicedate = new Date(this.editedItem.invoicedate)
        this.editedItem.importdate = new Date(this.editedItem.importdate)
        let ref = db.collection('import').doc(id).update(this.editedItem)
      } else {
        this.editedItem.grandtotal =parseFloat(this.editedItem.grandtotal)
        this.editedItem.orderdate = new Date(this.editedItem.orderdate)
        this.editedItem.invoicedate = new Date(this.editedItem.invoicedate)
        this.editedItem.importdate = new Date(this.editedItem.importdate)
        let ref = db.collection('import').add(this.editedItem)
      }
      this.initialize()
      this.close()
    },
    gotopageStockIn (item) {
      this.$router.push({ name: 'StockIn', params: { id:item.id  }})
    },
    financial(x) {
      return Number.parseFloat(x).toFixed(2);
    }
  }
}
</script>

<style>
.fontLao{
font-family: phetsarath ot !important;
}
.fixtable>div>  td:first-child,
.fixtable>div>  table.v-table tbody td:not(:first-child),
.fixtable>div>  table.v-table tbody th:first-child,
.fixtable>div>  table.v-table tbody th:not(:first-child),
.fixtable>div>  table.v-table thead td:first-child, 
.fixtable>div>  table.v-table thead td:not(:first-child),
.fixtable>div>  table.v-table thead th:first-child,
.fixtable>div>  table.v-table thead th:not(:first-child) {
    padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Import.vue